<template>
  <div class="page-container">
    <main class="main-content">
      <!-- Banner Ad Section -->
      <div v-if="bannerAds.length > 0" class="page-inner-box banner-section">
        <div v-for="ad in bannerAds" :key="ad.id" class="banner-item" @click="openAd(ad)">
          <img :src="sanitizeUrl(ad.adImage)" :alt="ad.adTitle" class="banner-img">
        </div>
      </div>

      <div class="page-inner-box detail-header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
          <el-breadcrumb-item>所有课程</el-breadcrumb-item>
          <el-breadcrumb-item>课程详情</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 课程简介卡片 -->
        <div class="hero-card">
          <div class="hero-body">
            <div class="thumb" :style="{ backgroundImage: `url(${course.image})` }"></div>
            <div class="info">
              <h1 class="title">{{ course.title }}</h1>
              <div class="desc">{{ course.desc }}</div>
              
              <div class="tags-row">
                <span class="tag-item blue-tag">分类：{{ course.category }}</span>
                <span class="tag-item purple-tag">该课程参与分销返现</span>
                <div class="stats-right">
                  <span>现有{{ course.lessonCount }}节</span>
                </div>
              </div>

              <div class="price-section">
                <div class="price-row">
                  <span class="currency">¥</span>
                  <span class="price">{{ (course.price || 0).toFixed(2) }}</span>
                  <span class="origin-price">原价：¥{{ (course.originPrice || 0).toFixed(2) }}</span>
                  <span class="student-count">{{ course.studentCount }}人已学</span>
                </div>
                <div v-if="discountCountdownVisible" class="countdown-row">
                  <span class="label">限时折扣倒计时：</span>
                  <div class="countdown-box">
                    <span class="time-block">{{ countdown.days }}天</span>
                    <span class="colon">:</span>
                    <span class="time-block">{{ countdown.hours }}时</span>
                    <span class="colon">:</span>
                    <span class="time-block">{{ countdown.minutes }}分</span>
                    <span class="colon">:</span>
                    <span class="time-block">{{ countdown.seconds }}秒</span>
                  </div>
                </div>
              </div>

              <div class="actions">
                <el-button class="buy-btn" type="primary" @click="goPayment">{{ isFreeCourse || course.isPurchased ? '立即学习' : '立即购买' }}</el-button>
                <div class="collect-btn" :class="{ active: isFavorite, disabled: favoriteLoading }" @click="toggleFavorite">
                  <i :class="isFavorite ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
                  <span>{{ isFavorite ? '已收藏' : '收藏' }}</span>
                </div>
                <el-popover
                  placement="bottom"
                  width="200"
                  trigger="click"
                  @show="generateShareQrCode"
                >
                  <div class="share-popover-content">
                    <div class="share-qr-title">扫码分享课程</div>
                    <img v-if="shareQrCode" :src="shareQrCode" alt="分享二维码" class="share-qr-img" />
                    <el-button size="mini" class="copy-link-btn" @click="copyShareLink">复制链接</el-button>
                  </div>
                  <div slot="reference" class="collect-btn">
                    <i class="el-icon-share"></i>
                    <span>分享</span>
                  </div>
                </el-popover>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="page-inner-box detail-content">
        <div class="left-column">
          <!-- 项目报名卡片 -->
          <div class="project-card" v-if="projects && projects.length">
            <div class="project-header">项目报名</div>
            <div>
              <div v-for="p in projects" :key="p.id" class="project-body">
                <div class="project-thumb" :style="{ backgroundImage: `url(${p.coverImage || course.image})` }"></div>
                <div class="project-info-actions">
                  <div class="project-info">
                    <div class="p-title">{{ p.title }}</div>
                    <div class="p-desc">{{ p.desc }}</div>
                  </div>
                  <div class="project-actions">
                    <el-button
                      type="primary"
                      size="small"
                      class="signup-btn"
                      :loading="!isProjectRegistered(p) && signupSubmitting && String(signupSubmittingProjectId) === String(p.id)"
                      :disabled="!isProjectRegistered(p) && signupSubmitting && String(signupSubmittingProjectId) !== String(p.id)"
                      @click="handleProjectPrimaryAction(p)"
                    >{{ isProjectRegistered(p) ? '您已报名' : '我要报名' }}</el-button>
                    <el-button plain size="small" class="more-btn" @click="goProjectDetail(p.id)">了解更多</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 详情/目录 Tab -->
          <div class="content-tabs">
            <!-- <div class="mobile-visit">
              <i class="el-icon-mobile-phone"></i> 手机访问
            </div> -->
            <el-tabs v-model="activeTab" class="custom-tabs">
              <el-tab-pane label="详情" name="detail">
                <div class="detail-pane">
                  <div class="sec-title">课程简介</div>
                  <div class="sec-body" v-html="course.introductionHtml || course.longDesc"></div>
                </div>
              </el-tab-pane>

              <el-tab-pane label="目录" name="syllabus">
                <div class="syllabus-header">
                  已更新{{ updatedLessons }}节/共{{ totalLessons }}节
                </div>
                
                <div class="syllabus-list">
                  <div v-for="(unit, index) in syllabus" :key="index" class="unit-group">
                    <div class="unit-title" @click="toggleUnit(index)">
                      {{ unit.title }}
                      <i :class="unit.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                    </div>
<div v-show="unit.expanded" class="lesson-list">
                       <div 
                         v-for="(lesson, lIndex) in unit.lessons" 
                         :key="lIndex" 
                         class="lesson-item"
                         @click="handleLessonClick(lesson, unit)"
                       >
                         <div class="l-left">
                           <i class="el-icon-video-play play-icon"></i>
                           <span class="l-title">{{ lesson.title }}</span>
                           <span v-if="lesson.isFree" class="free-tag">免费试看</span>
                         </div>
                         <div class="l-right">
                           <span v-if="lesson.progress" class="progress-text">学习进度：<span class="blue">{{ lesson.progress }}%</span></span>
                           <span v-else class="status-text">学习进度：未学习</span>
                           <i v-if="lesson.locked" class="el-icon-lock lock-icon"></i>
                           <i v-else class="el-icon-unlock unlock-icon"></i>
                         </div>
                       </div>
                     </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>

        <div class="right-column" v-if="hasTeacher || recommends.length > 0">
          <!-- 讲师卡片 -->
          <div v-if="hasTeacher" class="teacher-card" @click="goTeacherDetail">
            <div class="t-avatar">
              <el-avatar :size="72" :src="teacher.avatar">{{ teacher.name.substring(0,1) }}</el-avatar>
            </div>
            <div class="t-info">
              <div class="t-name">{{ teacher.name }}</div>
<!--              <div class="t-tag">-->
<!--                <span class="tag">财税金融</span>-->
<!--              </div>-->
              <div class="t-title">{{teacher.introduction}}</div>
            </div>
          </div>

          <!-- 课程推荐 -->
          <div v-if="recommends.length > 0" class="recommend-card">
            <div class="card-header">
              <span>课程推荐</span>
              <a href="#" class="more-link" @click.prevent="goAllCourses">更多 ></a>
            </div>
            <div class="rec-list">
              <div v-for="rec in recommends" :key="rec.id" class="rec-item" @click="goCourse(rec)">
                <div class="rec-cover" :style="{ backgroundImage: `url(${rec.coverImage})` }"></div>
                <div class="rec-details">
                  <div class="rec-title">{{ rec.title }}</div>
                  <div class="rec-tags">
                    <!-- <el-tag size="mini" effect="plain">建工安全</el-tag> -->
                  </div>
                  <div class="rec-meta">
                    <span class="rec-students">{{ rec.students }}人已学</span>
                    <span class="rec-price">{{ rec.price > 0 ? '¥'+rec.price : '免费' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <SignupDialog
      ref="signupDialogRef"
      :visible.sync="signupDialogVisible"
      :submitting="signupSubmitting"
      :project-title="signupProjectTitle"
      @submit="handleSignupSubmit"
      @cancel="handleSignupCancel"
    />

    <QuickPurchaseDialog
      :visible.sync="showPurchaseDialog"
      bizType="course"
      :itemId="purchaseItemId"
      :title="purchaseTitle"
      :image="purchaseImage"
      :price="purchasePrice"
      :distributorId="purchaseDistributorId"
      @purchased="handlePurchased"
    />

    <!-- Popup Ad -->
    <AdPopup v-if="popupAd" :ad="popupAd" page-id="course_detail" />

    <!-- Float Ad -->
    <AdFloat v-if="floatAd" :ad="floatAd" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SignupDialog from '@/components/SignupDialog.vue'
import QuickPurchaseDialog from '@/components/QuickPurchaseDialog.vue'
import AdPopup from '@/components/AdPopup.vue'
import AdFloat from '@/components/AdFloat.vue'
import { getCourseDetail, getCourseUnitsLessons, getHotCourseList, getMyFavorites, createMyFavorite, deleteMyFavorite, getProjectsByCourse, getStudyProgress, getAdvertisementList, addAdvertisementView } from '@/api/courseApi'
import { getMyProjects, registerProject, uploadFrontendFile, getPersonalInfo } from '@/api/authApi'
import QRCode from 'qrcode'

const defaultCourseCover = require('@/assets/image/study_placeholder.png')

export default {
  name: 'CourseDetail',
  components: { SignupDialog, QuickPurchaseDialog, AdPopup, AdFloat },
  data() {
    return {
      courseId: null,
      loading: false,
      activeTab: 'syllabus', // Default to directory as per screenshot
      countdown: { days: 21, hours: 4, minutes: 35, seconds: 5 },
      signupSubmitting: false,
      signupSubmittingProjectId: null,
      signupDialogVisible: false,
      signupProjectSelected: null,
      showPurchaseDialog: false,
      purchaseItemId: null,
      purchaseTitle: '',
      purchaseImage: '',
      purchasePrice: 0,
      purchaseDistributorId: null,
      courseProgressPercent: 0,
      courseProgressChecking: false,
      signupReminderPrompting: false,
      myProjectRegisteredMap: {},
      myProjectRegisteredAt: 0,
      myProjectRegisteredLoading: false,
      course: {
        title: '',
        desc: '',
        category: '',
        lessonCount: 0,
        studentCount: 0,
        price: 0,
        originPrice: 0,
        image: '',
        longDesc: '',
        introductionHtml: '',
        isPurchased: false,
        isDiscount: false,
        discountEndTime: null,
        learningModeName: ''
      },
      projects: [],
      projectsLoading: false,
      teacher: {
        name: '',
        avatar: '',
        title: '',
        introduction: ''
      },
      syllabus: [],
      recommends: [],
      hasTeacher: false,
      isFavorite: false,
      favoriteId: null,
      favoriteLoading: false,
      discountCountdownVisible: false,
      discountTimer: null,
      isFreeCourse: false,
      popupAd: null,
      bannerAds: [],
      floatAd: null,
      shareQrCode: ''
    }
  },
  created() {
    this.courseId = this.$route.params.id
    if (this.isLoggedIn) {
      this.refreshUserInfo()
    }
    this.fetchCourseDetail()
    this.fetchUnitsLessons()
    this.fetchFavoriteStatus()
    this.fetchHotCourses()
    this.fetchProjects()
    this.fetchAdvertisements()
  },
  mounted() {
    if (typeof window !== 'undefined' && window.addEventListener) {
      window.addEventListener('auth:login-success', this.handleAuthLoginSuccess)
    }
    this.$router.afterEach((to, from) => {
      if (to.name === 'course' && from.name === 'memberSettings') {
        this.refreshUserInfo()
      }
    })
  },
  beforeDestroy() {
    this.clearDiscountTimer()
    if (typeof window !== 'undefined' && window.removeEventListener) {
      window.removeEventListener('auth:login-success', this.handleAuthLoginSuccess)
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'userInfo', 'isRealNameVerified']),
    totalLessons() {
      return this.syllabus.reduce((acc, unit) => acc + unit.lessons.length, 0)
    },
    updatedLessons() {
      return this.totalLessons
    },
    primaryProject() {
      const list = Array.isArray(this.projects) ? this.projects : []
      return list.length ? list[0] : { id: null, title: '', desc: '', coverImage: '' }
    },
    signupProjectTitle() {
      const selected = this.signupProjectSelected
      if (selected && selected.title) return selected.title
      const primary = this.primaryProject
      return primary && primary.title ? primary.title : ''
    }
  },
  methods: {
    sanitizeUrl(val) {
      const s = String(val || '').trim()
      if (!s) return ''
      return s.replace(/\\`/g, '').replace(/`/g, '').trim()
    },
    toggleUnit(index) {
      if (index < 0 || index >= this.syllabus.length) return
      this.$set(this.syllabus[index], 'expanded', !this.syllabus[index].expanded)
    },
    handleLessonClick(lesson, unit) {
      if (!lesson) return
      
      const courseId = this.courseId || this.$route.params.id
      const lessonId = lesson.id
      const unitId = unit && unit.id
      
      // 免费试看课时：无需登录和购买即可学习
      if (lesson.isFree) {
        this.$router.push({
          name: 'learn',
          params: { id: courseId },
          query: { lessonId, unitId, trial: '1' }
        })
        return
      }
      
      // 非免费课时：需要登录
      if (!this.isLoggedIn) {
        window.dispatchEvent(new CustomEvent('auth:login-required', { detail: { redirect: this.$route.fullPath } }))
        return
      }
      
      // 非免费课时：需要购买课程
      const isPurchased = Boolean(this.course && (this.course.isPurchased || this.isFreeCourse))
      if (!isPurchased) {
        this.$message.warning('请先购买课程后再学习')
        return
      }
      
      this.$router.push({
        name: 'learn',
        params: { id: courseId },
        query: { lessonId, unitId }
      })
    },
    async fetchAdvertisements() {
      try {
        const res = await getAdvertisementList({
          displayPosition: 'course_detail'
        })
        if (res && res.data) {
          const list = Array.isArray(res.data) ? res.data : []
          const enabled = list.filter(item => Number(item && item.enableStatus) === 1 && Number(item && item.adStatus) === 1)
          
          // Process Popup Ads
          const popupAds = enabled.filter(item => String(item && item.adType) === 'popup')
          if (popupAds.length > 0) {
            this.popupAd = popupAds[0]
          }
          
          // Process Banner Ads
          this.bannerAds = enabled.filter(item => String(item && item.adType) === 'banner')
          
          // Process Float Ads
          const floatAds = enabled.filter(item => String(item && item.adType) === 'float')
          if (floatAds.length > 0) {
            this.floatAd = floatAds[0]
          }
        }
      } catch (error) {
        console.error('Failed to fetch advertisements:', error)
      }
    },
    openAd(ad) {
      if (!ad) return
      // Track view count
      if (ad.id) {
        addAdvertisementView(ad.id).catch(e => console.error('Failed to track ad view', e))
      }
      
      const url = this.sanitizeUrl(ad.linkUrl)
      if (url) {
        window.open(url, '_blank')
      }
    },
    sanitizeRichText(html) {
      const raw = String(html || '')
      if (!raw.trim()) return ''
      const cleaned = raw.replace(/\\`/g, '').replace(/`/g, '')
      try {
        const parser = new DOMParser()
        const doc = parser.parseFromString(cleaned, 'text/html')
        doc.querySelectorAll('script').forEach(node => node.remove())
        doc.querySelectorAll('*').forEach(el => {
          Array.from(el.attributes || []).forEach(attr => {
            const name = String(attr.name || '').toLowerCase()
            if (name.startsWith('on')) el.removeAttribute(attr.name)
          })
          if (el.hasAttribute('href')) {
            const href = this.sanitizeUrl(el.getAttribute('href'))
            if (/^javascript:/i.test(href)) el.removeAttribute('href')
            else el.setAttribute('href', href)
          }
          if (el.hasAttribute('src')) {
            const src = this.sanitizeUrl(el.getAttribute('src'))
            if (/^javascript:/i.test(src)) el.removeAttribute('src')
            else el.setAttribute('src', src)
          }
        })
        return doc.body.innerHTML || ''
      } catch (e) {
        return cleaned
      }
    },

    setupDiscountCountdown() {
      this.clearDiscountTimer()
      const endTime = this.course && this.course.discountEndTime
      const endTs = this.parseDatetime(endTime)
      if (!endTs) {
        this.discountCountdownVisible = false
        this.setCountdownByRemaining(0)
        return
      }
      const update = () => {
        const remaining = endTs - Date.now()
        if (remaining <= 0) {
          this.discountCountdownVisible = false
          this.setCountdownByRemaining(0)
          this.clearDiscountTimer()
          return
        }
        this.discountCountdownVisible = true
        this.setCountdownByRemaining(remaining)
      }
      update()
      this.discountTimer = setInterval(update, 1000)
    },
    parseDatetime(datetime) {
      if (!datetime) return null
      const parsed = Date.parse(datetime)
      return isNaN(parsed) ? null : parsed
    },
    setCountdownByRemaining(remaining) {
      const totalSeconds = Math.max(0, Math.floor(remaining / 1000))
      const days = Math.floor(totalSeconds / 86400)
      const hours = Math.floor((totalSeconds % 86400) / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60
      this.countdown = { days, hours, minutes, seconds }
    },
    clearDiscountTimer() {
      if (this.discountTimer) {
        clearInterval(this.discountTimer)
        this.discountTimer = null
      }
    },
    normalizeHotCourse(item) {
      const id = item && (item.id ?? item.courseId ?? item.course_id)
      const title = (item && (item.courseName ?? item.title ?? item.name)) || ''
      const coverImage = this.sanitizeUrl(item && (item.coverImage ?? item.cover ?? item.image))
      const priceRaw = item && (item.discountPrice ?? item.currentPrice ?? item.salePrice ?? item.price)
      const price = priceRaw == null ? 0 : Number(priceRaw)
      const studentsRaw = item && (item.viewCount ?? item.studentCount ?? item.students)
      const students = studentsRaw == null ? 0 : Number(studentsRaw)
      return {
        id,
        title,
        coverImage,
        price,
        students,
        raw: item
      }
    },
    async fetchHotCourses() {
      try {
        const res = await getHotCourseList({ limit: 10 })
        const data = res && res.data
        const list = Array.isArray(data)
          ? data
          : (Array.isArray(data && data.list)
              ? data.list
              : (Array.isArray(data && data.records) ? data.records : (Array.isArray(data && data.items) ? data.items : [])))
        this.recommends = list.map(this.normalizeHotCourse).filter(item => item && item.id != null)
      } catch (err) {
        this.recommends = []
      }
    },
    normalizeProject(item) {
      const id = item && (item.id ?? item.projectId ?? item.project_id)
      const title = String((item && (item.projectName ?? item.projectTitle ?? item.title ?? item.name)) || '').trim()
      const desc = String((item && (item.subtitle ?? item.description ?? item.desc)) || '').trim()
      const coverImage = this.sanitizeUrl(item && (item.coverImage ?? item.cover ?? item.image))
      return {
        id,
        title,
        desc,
        coverImage,
        raw: item
      }
    },
    async fetchProjects() {
      if (!this.courseId) return
      this.projectsLoading = true
      try {
        const res = await getProjectsByCourse(this.courseId)
        const data = res && res.data
        const list = Array.isArray(data)
          ? data
          : (Array.isArray(data && data.list)
              ? data.list
              : (Array.isArray(data && data.records) ? data.records : (Array.isArray(data && data.items) ? data.items : [])))
        this.projects = list.map(this.normalizeProject).filter(p => p && p.id != null)
        if (this.isLoggedIn) {
          await this.ensureMyProjectRegisteredMap(false)
        }
      } catch (err) {
        this.projects = []
      } finally {
        this.projectsLoading = false
      }
    },
    fetchCourseDetail() {
      if (!this.courseId) return
      
      this.loading = true
      getCourseDetail(this.courseId)
        .then(response => {
          if (response && response.data) {
            const courseData = response.data
            const teachers = Array.isArray(courseData.teachers) ? courseData.teachers : []
            const coverImage = this.sanitizeUrl(courseData.coverImage) || defaultCourseCover
            const introductionHtml = this.sanitizeRichText(courseData.introduction)
            this.course = {
              title: courseData.courseName || '',
              desc: courseData.subtitle || '',
              category: courseData.categoryName || '',
              lessonCount: 0, // API doesn't return lesson count
              studentCount: courseData.viewCount || 0,
              price: courseData.discountPrice || courseData.currentPrice || courseData.salePrice || 0,
              originPrice: courseData.salePrice || 0,
              image: coverImage,
              longDesc: '',
              introductionHtml,
              isHot: courseData.isHot || false,
              isDiscount: courseData.isDiscount || false,
              learningModeName: courseData.learningModeName || '',
              isPurchased: Boolean(courseData.isPurchased),
              discountEndTime: courseData.discountEndTime || ''
            }
            // 判断是否免费课程（价格为0）
            this.isFreeCourse = Number(courseData.currentPrice || courseData.salePrice || 0) === 0
            this.updateSyllabusLocks()
            this.setupDiscountCountdown()
            // Update teachers data
            this.hasTeacher = teachers.length > 0
            if (this.hasTeacher) {
              const mainTeacher = teachers[0]
              this.teacher = {
                id: mainTeacher.teacherId || mainTeacher.id || '',
                name: mainTeacher.teacherName || '',
                avatar: this.sanitizeUrl(mainTeacher.avatar),
                title: '', // API doesn't return teacher title
                introduction:mainTeacher.introduction
              }
            } else {
              this.teacher = { id: '', name: '', avatar: '', title: '', introduction: '' }
            }
          }
        })
        .catch(error => {
          console.error('获取课程详情失败:', error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateSyllabusLocks() {
      const isPurchased = Boolean(this.course && (this.course.isPurchased || this.isFreeCourse))
      const units = Array.isArray(this.syllabus) ? this.syllabus : []
      units.forEach(unit => {
        const lessons = Array.isArray(unit && unit.lessons) ? unit.lessons : []
        lessons.forEach(lesson => {
          const allowTrial = Boolean(lesson && lesson.isFree)
          if (lesson) {
            lesson.locked = !isPurchased && !allowTrial
          }
        })
      })
    },
    async fetchUnitsLessons() {
      if (!this.courseId) return
      try {
        const res = await getCourseUnitsLessons(this.courseId)
        const data = res && res.data
        const units = Array.isArray(data) ? data : []
        const sortByOrder = (items) => {
          const list = Array.isArray(items) ? items : []
          return list
            .map((item, idx) => {
              const orderRaw = item && (item.sortOrder ?? item.sort_order)
              const order = orderRaw == null ? null : Number(orderRaw)
              return { item, idx, order: Number.isNaN(order) ? null : order }
            })
            .sort((a, b) => {
              const ao = a.order
              const bo = b.order
              if (ao == null && bo == null) return a.idx - b.idx
              if (ao == null) return 1
              if (bo == null) return -1
              if (ao !== bo) return ao - bo
              return a.idx - b.idx
            })
            .map(row => row.item)
        }
        const isPurchased = Boolean(this.course && (this.course.isPurchased || this.isFreeCourse))
        const sortedUnits = sortByOrder(units)
        this.syllabus = sortedUnits.map((unit, index) => {
          const lessons = (unit && unit.lessons) || []
          const sortedLessons = sortByOrder(Array.isArray(lessons) ? lessons : [])
          const unitId = unit && (unit.id ?? unit.unitId ?? unit.unit_id)
          const normalizedLessons = sortedLessons.map((lesson, lIndex) => {
            const allowTrial = Number(lesson && lesson.allowTrial) === 1
            const isPublished = Number(lesson && lesson.isPublished) === 1
            const durationRaw = lesson && (lesson.duration ?? lesson.durationSeconds ?? lesson.duration_seconds)
            const duration = durationRaw == null ? null : Number(durationRaw)
            const trialDurationRaw = lesson && (lesson.trialDuration ?? lesson.trial_duration)
            const trialDuration = trialDurationRaw == null ? null : Number(trialDurationRaw)
            return {
              id: (lesson && (lesson.id ?? lesson.lessonId ?? lesson.lesson_id)) ?? `${unitId ?? index}-${lIndex}`,
              title: (lesson && (lesson.lessonName ?? lesson.title ?? lesson.name)) || `课时${lIndex + 1}`,
              isFree: allowTrial,
              locked: !isPurchased && !allowTrial,
              progress: null,
              isPublished,
              videoUrl: lesson && (lesson.videoUrl ?? lesson.video_url),
              handoutUrl: lesson && (lesson.handoutUrl ?? lesson.handout_url),
              contentType: lesson && (lesson.contentType ?? lesson.content_type),
              duration: Number.isNaN(duration) ? null : duration,
              trialDuration: Number.isNaN(trialDuration) ? null : trialDuration,
              lessonType: lesson && (lesson.lessonType ?? lesson.lesson_type),
              paperId: lesson && (lesson.paperId ?? lesson.paper_id),
              questionRules: lesson && (lesson.questionRules ?? lesson.question_rules),
              sortOrder: lesson && (lesson.sortOrder ?? lesson.sort_order),
              raw: lesson
            }
          })
          return {
            id: unitId,
            title: (unit && (unit.unitName ?? unit.title ?? unit.name)) || `单元${index + 1}`,
            expanded: index === 0,
            lessons: normalizedLessons,
            sortOrder: unit && (unit.sortOrder ?? unit.sort_order),
            raw: unit
          }
        })
        this.course.lessonCount = this.totalLessons
        this.loadLessonProgressesAndMaybeRemind()
      } catch (err) {
        this.syllabus = []
        this.course.lessonCount = 0
        this.$message.error((err && err.message) || '获取课程目录失败')
      }
    },
    getShareLink() {
      const distributorId = this.userInfo && this.userInfo.id ? this.userInfo.id : ''
      // 使用当前页面地址作为分享链接基础地址
      const baseUrl = window.location.origin
      
      const route = this.$router.resolve({
        query: {
          ...this.$route.query,
          ...(distributorId ? { distributorId } : {})
        }
      })
      
      return `${baseUrl}${route.href.startsWith('/') ? '' : '/'}${route.href}`
    },
    async generateShareQrCode() {
      const link = this.getShareLink()
      try {
        this.shareQrCode = await QRCode.toDataURL(link, {
          width: 180,
          margin: 1,
          color: { dark: '#000000', light: '#FFFFFF' }
        })
      } catch (err) {
        console.error('Failed to generate QR code', err)
      }
    },
    copyShareLink() {
      const link = this.getShareLink()
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link).then(() => {
          this.$message.success('链接已复制，去分享给好友吧！')
        }).catch(() => {
          this.fallbackCopyText(link)
        })
      } else {
        this.fallbackCopyText(link)
      }
    },
    fallbackCopyText(text) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.top = '0'
      textArea.style.left = '0'
      textArea.style.position = 'fixed'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$message.success('链接已复制，去分享给好友吧！')
        } else {
          this.$message.error('复制链接失败，请手动复制')
        }
      } catch (err) {
        this.$message.error('复制链接失败，请手动复制')
      }
      document.body.removeChild(textArea)
    },
    goPayment() {
      if (!this.isLoggedIn) {
        window.dispatchEvent(new CustomEvent('auth:login-required', { detail: { redirect: this.$route.fullPath } }))
        return
      }
      const id = this.courseId || this.$route.params.id
      if (this.isFreeCourse || (this.course && this.course.isPurchased)) {
        this.$router.push({ name: 'learn', params: { id } })
        return
      }

      this.$router.push({
        name: 'purchaseConfirm',
        params: { type: 'course', id }
      })
    },
    handlePurchased() {
      const id = this.courseId || this.$route.params.id
      this.$router.push({ name: 'learn', params: { id } })
    },
    goCourse(rec) {
      const id = rec && rec.id
      if (id == null || id === '') return
      // 已购买直接跳学习页
      if (rec.isPurchased && this.$store.getters['auth/isLoggedIn']) {
        this.$router.push({ name: 'learn', params: { id } })
        return
      }
      this.$router.push({ name: 'course', params: { id } })
    },
    goAllCourses() {
      this.$router.push({ name: 'courseList' })
    },
    goTeacherDetail() {
      if (this.teacher && this.teacher.id) {
        this.$router.push({ name: 'teacherDetail', params: { id: this.teacher.id } })
      }
    },
    goProjectDetail(projectId) {
      const id = projectId || (this.primaryProject && this.primaryProject.id) || this.courseId || this.$route.params.id || 1
      this.$router.push({ name: 'projectDetail', params: { id } })
    },
    async fetchFavoriteStatus() {
      if (!this.isLoggedIn) {
        this.isFavorite = false
        this.favoriteId = null
        return
      }
      try {
        const res = await getMyFavorites({ courseId: this.courseId })
        const data = res && res.data
        const list = Array.isArray(data)
          ? data
          : (Array.isArray(data && data.list)
              ? data.list
              : (Array.isArray(data && data.records) ? data.records : (Array.isArray(data && data.items) ? data.items : [])))
        const match = list.find(item => {
          const cid = item && (item.courseId ?? item.course_id)
          return String(cid) === String(this.courseId)
        })
        if (match) {
          this.isFavorite = true
          this.favoriteId = match.id ?? match.favoriteId ?? match.favorite_id
        } else {
          this.isFavorite = false
          this.favoriteId = null
        }
      } catch (err) {
        this.isFavorite = false
        this.favoriteId = null
      }
    },
    async toggleFavorite() {
      if (this.favoriteLoading) return
      this.favoriteLoading = true
      try {
        if (this.isFavorite) {
          const id = this.favoriteId
          if (id == null || id === '') {
            await this.fetchFavoriteStatus()
          }
          const finalId = this.favoriteId
          if (finalId == null || finalId === '') {
            throw new Error('缺少收藏ID，无法取消收藏')
          }
          await deleteMyFavorite(finalId)
          this.isFavorite = false
          this.favoriteId = null
          this.$message.success('已取消收藏')
        } else {
          const res = await createMyFavorite(this.courseId)
          const data = res && res.data
          const newId = data && (data.id ?? data.favoriteId ?? data.favorite_id)
          this.isFavorite = true
          this.favoriteId = newId || this.favoriteId
          if (this.favoriteId == null || this.favoriteId === '') {
            await this.fetchFavoriteStatus()
          }
          this.$message.success('已加入收藏')
        }
      } catch (err) {
        this.$message.error((err && err.message) || (this.isFavorite ? '取消收藏失败' : '收藏失败'))
      } finally {
        this.favoriteLoading = false
      }
    },
    async signupProject(project) {
      const projectId = project && (project.id ?? project.projectId)
      if (projectId == null || projectId === '') {
        this.$message.error('缺少项目ID，无法报名')
        return
      }
      await this.openSignupDialog(project)
    },
    handleSignupCancel() {
      this.signupDialogVisible = false
    },
    extractListFromApiData(data) {
      if (Array.isArray(data)) return data
      if (data && Array.isArray(data.list)) return data.list
      if (data && Array.isArray(data.records)) return data.records
      if (data && Array.isArray(data.items)) return data.items
      return []
    },
    normalizeIsRegistered(val) {
      if (val === true || val === 1 || val === '1' || val === 'true') return true
      if (val === false || val === 0 || val === '0' || val === 'false') return false
      return !!val
    },
    async ensureMyProjectRegisteredMap(force = false) {
      if (!this.isLoggedIn) return
      if (this.myProjectRegisteredLoading) return
      const now = Date.now()
      const ttlMs = 30 * 1000
      if (!force && this.myProjectRegisteredAt && now - this.myProjectRegisteredAt < ttlMs) return
      this.myProjectRegisteredLoading = true
      try {
        const res = await getMyProjects({ pageNum: 1, pageSize: 200 })
        const list = this.extractListFromApiData(res && res.data)
        const map = {}
        list.forEach((raw) => {
          const projectId = raw && (raw.projectId ?? raw.id)
          if (projectId == null || projectId === '') return
          const isRegistered =
            this.normalizeIsRegistered(raw && raw.isRegistered) ||
            this.normalizeIsRegistered(raw && raw.is_registered) ||
            this.normalizeIsRegistered(raw && raw.registered) ||
            Boolean(raw && (raw.registrationTime || raw.registerTime || raw.register_time))
          map[String(projectId)] = Boolean(isRegistered)
        })
        this.myProjectRegisteredMap = map
        this.myProjectRegisteredAt = now
      } catch (e) {
        this.myProjectRegisteredMap = {}
        this.myProjectRegisteredAt = now
      } finally {
        this.myProjectRegisteredLoading = false
      }
    },
    async isUserInProject(projectId) {
      if (!this.isLoggedIn) return false
      await this.ensureMyProjectRegisteredMap(false)
      return this.myProjectRegisteredMap && this.myProjectRegisteredMap[String(projectId)] === true
    },
    async openSignupDialog(project) {
      console.log('CourseDetail - 实名认证状态:', this.isRealNameVerified, 'userInfo:', this.userInfo)
      const p = project || this.primaryProject
      const projectId = p && (p.id ?? p.projectId)
      if (projectId == null || projectId === '') {
        this.$message.error('缺少项目ID，无法报名')
        return
      }
      if (!this.isLoggedIn) {
        this.$message.error('请先登录')
        return
      }
      const alreadyInProject = await this.isUserInProject(projectId)
      if (alreadyInProject) {
        this.$message.success('您已报名该项目')
        return
      }
      if (!this.isRealNameVerified) {
        this.forceRealNameVerification()
        return
      }
      this.signupProjectSelected = {
        id: projectId,
        title: (p && p.title) || '',
        raw: p && p.raw
      }
      this.signupDialogVisible = true
    },
    async forceRealNameVerification() {
      try {
        await this.$confirm('报名前需要完成实名认证，是否现在去实名认证？', '实名认证提醒', {
          confirmButtonText: '去认证',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          distinguishCancelAndClose: true
        })
        this.$router.push('/member-center/settings').catch(() => {})
      } catch (e) {
        void e
      }
    },
    normalizeUploadedUrl(res) {
      const data = res && res.data
      if (typeof data === 'string') return data
      if (!data || typeof data !== 'object') return ''
      return (
        data.url ||
        data.fileUrl ||
        data.fileURL ||
        data.path ||
        data.filePath ||
        data.fullPath ||
        data.downloadUrl ||
        ''
      )
    },
    async handleSignupSubmit(form) {
      if (this.signupSubmitting) return
      const selected = this.signupProjectSelected || this.primaryProject
      const projectId = selected && selected.id
      if (projectId == null || projectId === '') {
        this.$message.error('缺少项目ID，无法报名')
        return
      }
      if (!this.isLoggedIn) {
        this.$message.error('请先登录')
        return
      }
      const alreadyInProject = await this.isUserInProject(projectId)
      if (alreadyInProject) {
        this.signupDialogVisible = false
        this.$message.success('您已报名该项目')
        return
      }
      if (!this.isRealNameVerified) {
        this.forceRealNameVerification()
        return
      }
      this.signupSubmitting = true
      this.signupSubmittingProjectId = projectId
      try {
        const files = form && Array.isArray(form.uploadFiles) ? form.uploadFiles : []
        const uploadUrls = []
        for (const file of files) {
          const res = await uploadFrontendFile(file, `project-registration/${projectId}`)
          const url = this.normalizeUploadedUrl(res)
          if (url) uploadUrls.push(url)
        }

        const payload = {
          ...(form || {}),
          uploadFiles: uploadUrls,
          courseId: this.courseId
        }
        const res = await registerProject(projectId, payload)
        if (res && Number(res.code) === 200) {
          this.$message.success(res.message || '报名成功')
          await this.ensureMyProjectRegisteredMap(true)
          this.dismissSignupReminder()
          this.signupDialogVisible = false
          if (this.$refs.signupDialogRef && this.$refs.signupDialogRef.reset) {
            this.$refs.signupDialogRef.reset()
          }
          return
        }
        this.$message.error((res && (res.message || res.msg)) || '报名失败')
      } catch (err) {
        this.$message.error((err && err.message) || '报名失败')
      } finally {
        this.signupSubmitting = false
        this.signupSubmittingProjectId = null
      }
    },
    getSignupReminderStorageKey() {
      const info = this.userInfo || {}
      const userId = info.id ?? info.userId ?? info.uid ?? 'guest'
      return `signupReminderDismissed:${userId}:${this.courseId}`
    },
    isSignupReminderDismissed() {
      try {
        return localStorage.getItem(this.getSignupReminderStorageKey()) === '1'
      } catch (e) {
        return false
      }
    },
    dismissSignupReminder() {
      try {
        localStorage.setItem(this.getSignupReminderStorageKey(), '1')
      } catch (e) {
        void e
      }
    },
    handleAuthLoginSuccess() {
      this.refreshUserInfo()
      this.fetchCourseDetail()
      this.fetchUnitsLessons()
      this.ensureMyProjectRegisteredMap(true)
      this.loadLessonProgressesAndMaybeRemind()
    },
    async refreshUserInfo() {
      try {
        const res = await getPersonalInfo()
        console.log('CourseDetail - getPersonalInfo 返回:', res)
        if (res && res.data) {
          console.log('CourseDetail - isRealNameVerified:', res.data.isRealNameVerified)
          this.$store.dispatch('auth/updateUserInfo', res.data)
        }
      } catch (e) {
        void e
      }
    },
    isProjectRegistered(project) {
      const projectId = project && (project.id ?? project.projectId)
      if (projectId == null || projectId === '') return false
      return Boolean(this.myProjectRegisteredMap && this.myProjectRegisteredMap[String(projectId)] === true)
    },
    goMemberProjects() {
      this.$router.push({ name: 'memberProjects' }).catch(() => {})
    },
    handleProjectPrimaryAction(project) {
      if (this.isProjectRegistered(project)) {
        this.goMemberProjects()
        return
      }
      this.signupProject(project)
    },
    async loadLessonProgressesAndMaybeRemind() {
      if (this.courseProgressChecking) return
      if (!this.isLoggedIn || !this.courseId) return
      const dismissed = this.isSignupReminderDismissed()
      if (dismissed) {
        this.courseProgressPercent = 0
      }
      const lessonEntries = []
      ;(this.syllabus || []).forEach(unit => {
        (unit && unit.lessons ? unit.lessons : []).forEach(lesson => {
          if (!lesson || !lesson.id) return
          if (lesson.lessonType !== 1) return
          lessonEntries.push(lesson)
        })
      })
      if (lessonEntries.length === 0) return

      this.courseProgressChecking = true
      try {
        const byId = {}
        lessonEntries.forEach(lesson => {
          byId[String(lesson.id)] = lesson
        })
        const ids = Object.keys(byId)
        const concurrency = 5
        let cursor = 0
        let completed = 0
        const worker = async () => {
          while (cursor < ids.length) {
            const idx = cursor
            cursor += 1
            const sectionId = ids[idx]
            const numericLessonId = Number(sectionId)
            const lessonId = Number.isFinite(numericLessonId) ? numericLessonId : sectionId
            try {
              const res = await getStudyProgress({ courseId: this.courseId, lessonId })
              const progressRaw = res && res.data && res.data.progress
              const progress = progressRaw == null ? null : Number(progressRaw)
              const lesson = byId[sectionId]
              if (lesson) {
                this.$set(lesson, 'progress', Number.isFinite(progress) ? Math.round(progress) : null)
              }
              if (Number(progress) === 100) completed += 1
            } catch (e) {
              void e
            }
          }
        }
        const tasks = Array.from({ length: Math.min(concurrency, ids.length) }, () => worker())
        await Promise.all(tasks)

        this.courseProgressPercent = ids.length ? Math.round((completed / ids.length) * 100) : 0
        if (this.courseProgressPercent === 100 && !this.isSignupReminderDismissed()) {
          this.promptSignupReminderOnce()
        }
      } finally {
        this.courseProgressChecking = false
      }
    },
    async promptSignupReminderOnce() {
      if (this.signupReminderPrompting) return
      if (this.signupDialogVisible) return
      if (!this.projects || this.projects.length === 0) return
      if (this.isSignupReminderDismissed()) return
      if (this.isLoggedIn) {
        const primaryId = this.primaryProject && this.primaryProject.id
        if (primaryId != null && primaryId !== '') {
          const alreadyInProject = await this.isUserInProject(primaryId)
          if (alreadyInProject) {
            this.dismissSignupReminder()
            return
          }
        }
      }
      this.signupReminderPrompting = true
      try {
        await this.$confirm('课时进度已达100%，是否现在报名？', '报名提醒', {
          confirmButtonText: '去报名',
          cancelButtonText: '暂不报名',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          distinguishCancelAndClose: true
        })
        await this.openSignupDialog(this.primaryProject)
      } catch (e) {
        this.dismissSignupReminder()
      } finally {
        this.signupReminderPrompting = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  min-height: 100vh;
  background-color: #f5f7fa;
}

.main-content {
  flex: 1;
  padding-top: 20px;
}

.detail-header {
  margin-bottom: 20px;
}

/* Hero Card */
.hero-card {
  background: #fff;
  padding: 24px;
  border-radius: 4px;
  margin-top: 15px;
  
  .hero-body {
    display: flex;
    gap: 30px;
  }
  
  .thumb {
    width: 480px;
    height: 300px;
    background-size: cover;
    background-position: center;
    border-radius: 4px;
    flex-shrink: 0;
  }
  
  .info {
    flex: 1;
    display: flex;
    flex-direction: column;
    
    .title {
      font-size: 22px;
      color: #333;
      margin-bottom: 12px;
      font-weight: bold;
    }
    
    .desc {
      font-size: 14px;
      color: #666;
      line-height: 1.5;
      margin-bottom: 16px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    
    .tags-row {
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #666;
      margin-bottom: 20px;
      
      .tag-item {
        margin-right: 15px;
        padding: 4px 12px;
        border-radius: 4px;
        font-size: 12px;
        
        &.blue-tag {
          background: #e6f7ff;
          color: #4034eb;
        }
        
        &.purple-tag {
          background: #eef1ff;
          color: #722ed1;
        }
      }
      
      .stats-right {
        margin-left: auto;
        display: flex;
        align-items: center;
        
        .divider {
          width: 1px;
          height: 12px;
          background: #ddd;
          margin: 0 10px;
        }
      }
    }
    
    .price-section {
      background: none;
      padding: 0;
      border-radius: 0;
      margin-bottom: 25px;
      
      .price-row {
        margin-bottom: 15px;
        
        .currency {
          color: #d93025;
          font-size: 24px;
          font-weight: bold;
        }
        .price {
          color: #d93025;
          font-size: 40px;
          font-weight: bold;
          margin-right: 15px;
        }
        .origin-price {
          color: #999;
          text-decoration: line-through;
          font-size: 14px;
        }
        .student-count {
          float: right;
          color: #666;
          font-size: 14px;
          margin-top: 15px;
        }
      }
      
      .countdown-row {
        display: flex;
        align-items: center;
        
        .label {
          color: #666;
          font-size: 13px;
          margin-right: 8px;
        }
        
        .countdown-box {
          display: flex;
          gap: 4px;
          align-items: center;
          
          .time-block {
            background: #d93025;
            color: #fff;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 16px;
            min-width: 36px;
            text-align: center;
            font-weight: 500;
          }
          
          .colon {
            color: #666;
            font-weight: normal;
            margin: 0 2px;
          }
        }
      }
    }
    
    .actions {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
      
      .buy-btn {
        background-color: #4034eb;
        border-color: #4034eb;
        padding: 12px 60px;
        font-size: 16px;
        border-radius: 4px;
        
        &:hover {
          background-color: #554af0;
          border-color: #554af0;
        }
      }
      
      .collect-btn {
        display: flex;
        align-items: center;
        gap: 5px;
        color: #666;
        cursor: pointer;
        
        &.active {
          color: #4034eb;
        }

        &.disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }

        &:not(.disabled):hover {
          color: #4034eb;
        }
        
        i {
          font-size: 18px;
        }
      }
    }
  }
}

/* Content Layout */
.detail-content {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.left-column {
  flex: 1;
}

.right-column {
  width: 280px;
  flex-shrink: 0;
}

/* Project Card */
.project-card {
  background: #fff;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 20px;
  
  .project-header {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #333;
  }
  
  .project-body {
    display: flex;
    gap: 15px;
    align-items: flex-start;

    & + .project-body {
      margin-top: 16px;
      padding-top: 16px;
      border-top: 1px solid #f0f0f0;
    }
    
    .project-thumb {
      width: 140px;
      height: 90px;
      background: #eee;
      border-radius: 4px;
      background-size: cover;
      background-position: center;
      flex-shrink: 0;
      margin-right: 20px;
    }
    
    .project-info-actions {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 20px;
      margin-left: 0;
    }
    
    .project-info {
      flex: 1;
      
      .p-title {
        font-weight: bold;
        color: #333;
        font-size: 15px;
        margin-bottom: 8px;
      }
      .p-desc {
        font-size: 13px;
        color: #666;
        line-height: 1.6;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
    
    .project-actions {
      display: flex;
      flex-direction: column;
      gap: 10px;
      //margin-left: 0;
      width: 140px;
      
      .signup-btn {
        background-color: #4034eb;
        border-color: #4034eb;
        padding: 9px 0;
        font-size: 13px;
        border-radius: 4px;
        width: 100%;
      }
      
      .more-btn {
        color: #4034eb;
        border-color: #4034eb;
        padding: 9px 0;
        font-size: 13px;
        border-radius: 4px;
        width: 100%;
        margin-left: 0;
        
        &:hover {
          background-color: #f0f0ff;
          border-color: #4034eb;
          color: #4034eb;
        }
      }
    }
  }
}

/* Tabs & Syllabus */
.content-tabs {
  background: #fff;
  border-radius: 4px;
  position: relative;
  min-height: 500px;
  
  .mobile-visit {
    position: absolute;
    right: 20px;
    top: 15px;
    font-size: 13px;
    color: #666;
    z-index: 10;
    cursor: pointer;
    
    &:hover { color: #4034eb; }
  }
}

.custom-tabs ::v-deep .el-tabs__header {
  margin-bottom: 0;
}

.custom-tabs ::v-deep .el-tabs__nav-wrap {
  padding: 0 20px;
}

.syllabus-header {
  padding: 15px 20px;
  font-size: 13px;
  color: #4034eb;
  background: #f5f7fa;
  border-bottom: 1px solid #eee;
}

.unit-group {
  .unit-title {
    padding: 15px 20px;
    background: #eef2ff;
    color: #333;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #fff;
    
    &:hover { background: #e0e7ff; }
  }
  
  .lesson-list {
    .lesson-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px;
      border-bottom: 1px solid #f5f5f5;
      font-size: 14px;
      cursor: pointer;
      
      &:hover { background: #fafafa; }
      
      .l-left {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #333;
        
        .play-icon { color: #ccc; font-size: 16px; }
        .free-tag {
          background: #4034eb;
          color: #fff;
          font-size: 12px;
          padding: 1px 4px;
          border-radius: 2px;
          transform: scale(0.9);
        }
      }
      
      .l-right {
        display: flex;
        align-items: center;
        gap: 15px;
        font-size: 12px;
        color: #999;
        
        .blue { color: #4034eb; }
        .lock-icon { color: #ccc; font-size: 16px; }
        .unlock-icon { color: #4034eb; font-size: 16px; }
      }
    }
  }
}

.detail-pane {
  padding: 20px;
  line-height: 1.8;
  color: #333;
  
  .sec-title {
    font-weight: bold;
    margin-bottom: 10px;
  }

  .sec-body {
    text-align: center;
    ::v-deep p {
      text-align: center;
      margin: 0;
    }
    ::v-deep img {
      max-width: 100%;
      height: auto;
      display: block;
      margin: 0 auto;
    }
  }
}

/* Right Column */
.teacher-card {
  background: #fff;
  border-radius: 4px;
  padding: 25px 20px;
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 20px;
  cursor: pointer;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  }

  ::v-deep .el-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  
  .t-info {
    flex: 1;
    min-width: 0;
    .t-name { font-weight: bold; font-size: 16px; margin-bottom: 5px; }
    .t-tag {
      margin-bottom: 8px;
      .tag {
        background-color: #eef1ff;
        color: #4034eb;
        font-size: 12px;
        padding: 2px 6px;
        border-radius: 2px;
      }
    }
    .t-title {
      font-size: 12px;
      color: #666;
      line-height: 1.4;
      display: -webkit-box;
      -webkit-line-clamp: 6;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.recommend-card {
  background: #fff;
  border-radius: 4px;
  padding: 15px;
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
    
    .more-link { font-size: 12px; color: #999; font-weight: normal; }
  }
  
  .rec-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
    
    .rec-item {
      cursor: pointer;
      border-bottom: 1px dashed #eee;
      padding-bottom: 15px;
      
      &:last-child { border-bottom: none; padding-bottom: 0; }
      
      .rec-cover {
        width: 100%;
        height: 100px;
        border-radius: 4px;
        margin-bottom: 8px;
        background-size: cover;
      }
      
      .rec-title {
        font-size: 13px;
        color: #333;
        margin-bottom: 6px;
        line-height: 1.4;
      }
      
      .rec-tags { margin-bottom: 6px; }
      
      .rec-meta {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        
        .rec-students { color: #999; }
        .rec-price { color: #ff4d4f; }
      }
    }
  }
}

@media (max-width: 992px) {
  .hero-card .hero-body { flex-direction: column; }
  .hero-card .thumb { width: 100%; height: 200px; }
  
  .detail-content { flex-direction: column; }
  .right-column { width: 100%; }
}

/* Banner Section */
.banner-section {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.banner-item {
  width: 100%;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  height: 120px;
}
.banner-img {
  width: 100%;
  height: auto;
  display: block;
}

/* Ad Popup */
::v-deep .ad-popup-dialog {
  background: transparent !important;
  box-shadow: none !important;
  
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    background: transparent;
  }
}
.ad-popup-content {
  position: relative;
  cursor: pointer;
  
  img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 8px;
  }
}

/* Float Ad */
.float-ad {
  position: fixed;
  right: 20px;
  bottom: 100px;
  width: 120px;
  z-index: 2000;
  cursor: pointer;
  
  img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
  
  .float-ad-close {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 20px;
    height: 20px;
    background: rgba(0,0,0,0.5);
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    cursor: pointer;
    
    &:hover {
      background: rgba(0,0,0,0.7);
    }
  }
}
</style>
